import React from "react";
import ApiCard from "../components/ApiCard";
export default function RegistrationCallback() {
    return (
        <ApiCard
            title="Registration Callback"
            description="Simulate Registration Callback"
            url="abdm/registration/"
            method="POST"
            payload={{
                requestId: crypto.randomUUID(),
                timestamp: new Date().toISOString(),
                acknowledgement: {
                    status: "OK"
                }
            }}
            buttonText="Execute Callback"
        />
    );
}